import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import LeftArrow from '../../../assets/icons/General/arrow.svg?react';
import intellectLogo from '../../../assets/icons/Logo-new.png';
import loginBg from '../../../assets/icons/login-bg.png';
import { IResetPassword } from '../../../shared/types/ResetPassword';
import { ResetScreens } from '../../../shared/constants/ResetPassword';
import useAuth from '../../../utilities/hooks/useAuth';

interface ILogoutprops {
  children: React.ReactNode;
  title: string;

  subTitle?: any;
  backButton?: boolean;
  currentState?: number;
  setState?: IResetPassword['setState'];
}
function LoginLayout({
  children,
  title,
  subTitle,
  backButton,
  setState,
  currentState,
}: ILogoutprops) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  useLayoutEffect(() => {
    if (user) {
      navigate('/d/dimensions');
    }
  }, [user]);

  return (
    <div className="grid h-screen  grid-cols-1 lg:grid-cols-2 ">
      <div className="mx-autoflex-col grid items-center overflow-auto">
        <div className="absolute left-0 top-0 z-[1] w-full bg-white pb-2 pl-8 pt-8">
          <img src={intellectLogo} className="h-8" alt="" />
        </div>

        <div className="m-auto w-full max-w-[480px] gap-5 px-5 sm:pb-6  sm:pt-24 xl:pb-0 2xl:pt-0">
          {backButton && (
            <div
              onClick={() => {
                if (currentState) {
                  if (currentState === ResetScreens.EMAIL_SCREEN)
                    navigate('/login');
                  else
                    setState?.({
                      currentScreen: currentState - 1,
                    });
                }
              }}
              className="mb-6 h-8 w-8 cursor-pointer select-none items-center justify-center rounded-[3px] transition-all duration-150 hover:bg-black-200  active:bg-black-400 lg:flex"
            >
              <LeftArrow className="h-[18.67px] w-[18.67px] rotate-90 stroke-black-900" />
            </div>
          )}
          <p className=" mb-[6px] text-3xl font-semibold leading-[38px] text-black-900">
            {title}
          </p>
          <p className=" text-black-600">{subTitle}</p>
          {children}
        </div>
      </div>
      <div
        className="relative z-[2] hidden content-center bg-cover bg-center bg-no-repeat lg:grid"
        style={{ backgroundImage: `url(${loginBg})` }}
      >
        <div className="m-auto -mt-20 px-[62px] ">
          <p className="mt-2 text-[32px] font-medium leading-[48px] text-white">
            {t('LOGIN_HEADLINE')}
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoginLayout;
